import React, { useContext } from 'react';
import { store } from '../store';
import { CircularProgress } from '@mui/material';
import useGetAppParams from '../fetch/useGetAppParams';
import AppParamTable from './AppParamTable';

const AppParams = ({ match, ...rest }) => {
	const { dispatch } = useContext(store);
	const appID = match?.params?.appID ?? 0;
	const { data, isFetching } = useGetAppParams(appID, dispatch);

	return isFetching ? (
		<CircularProgress />
	) : (
		<AppParamTable data={data} match={match} {...rest} />
	);
};
export default AppParams;
